// Auto-generated by scripts/generate-registry.mjs from packages/modules/lipstick_screw_case/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const lipstick_screw_case: ModuleSchema = {
  "id": "lipstick_screw_case",
  "uniqueId": "B3D_LSC01",
  "createdAt": "2026-10-19T00:00:00Z",
  "updatedAt": "2026-10-19T15:44:23.150Z",
  "label": "Lipstick Screw Case",
  "description": "Two-piece hollow case with a nominally interlocking rounded screw thread.",
  "category": "app_model",
  "tags": [
    "lipstick",
    "two-piece",
    "rounded-thread"
  ],
  "sliders": [
    {
      "key": "lipstickDiameter",
      "label": "Lipstick Diameter",
      "min": 10,
      "max": 28,
      "default": 22,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "lipstickLength",
      "label": "Lipstick Length",
      "min": 40,
      "max": 100,
      "default": 71,
      "step": 1,
      "unit": "mm",
      "targetGroupIds": [
        0,
        1
      ]
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "body",
      "label": "Body — 45 mm barrel + 12 mm connector",
      "default": "#c9bda1",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "cap",
      "label": "Cap — 35 mm",
      "default": "#978b73",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "body",
      "label": "Body",
      "name": "Body",
      "color": "#c9bda1",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "body",
          "label": "Body — 45 mm barrel + 12 mm connector",
          "name": "Body — 45 mm barrel + 12 mm connector",
          "groupId": 0,
          "colorKey": "body",
          "defaultColor": "#c9bda1",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0
        }
      ]
    },
    {
      "id": "cap",
      "label": "Cap",
      "name": "Cap",
      "color": "#978b73",
      "assembled_z_offset": 0,
      "exploded_z_offset": 15,
      "parts": [
        {
          "id": "cap",
          "label": "Cap — 35 mm",
          "name": "Cap — 35 mm",
          "groupId": 1,
          "colorKey": "cap",
          "defaultColor": "#978b73",
          "assembled_z_offset": 0,
          "exploded_z_offset": 15
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL — Full Case",
      "groupIds": [
        0,
        1
      ]
    },
    {
      "id": "body",
      "label": "Download STL — Body",
      "groupIds": [
        0
      ]
    },
    {
      "id": "cap",
      "label": "Download STL — Cap",
      "groupIds": [
        1
      ]
    }
  ]
};
